import { Popup as SemanticPopup } from 'semantic-ui-react';

export { PopupProps, StrictPopupProps } from 'semantic-ui-react';

export const Popup: typeof SemanticPopup = SemanticPopup;

export default Popup;
